import ShareIcon from "@ch/assets/icons/pack/ShareIcon";
import TickCircleIcon from "@ch/assets/icons/pack/TickCircleIcon";
import Button from "@ch/components/Buttons/Button";
import Modal from "@ch/components/Modals/Modal";
import type {
  UserSubscriptions,
  UserSubscriptionsWithRelations,
} from "@ch/generated";
import moment from "moment";
import { startTransition } from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  modalId: string;
  price: number;
  subscription: UserSubscriptions | UserSubscriptionsWithRelations;
  reference: string;
}

const PaymentSuccessfulModal = ({
  modalId,
  price,
  subscription,
  reference,
}: Props) => {
  const navigate = useNavigate();
  const takeBLA = () => {
    startTransition(() =>
      navigate(
        `/subscriptions/${subscription?.id}/program/${subscription?.programId}/BLA/start`,
      ),
    );
  };

  return (
    <Modal
      closeOnClickESC
      footerComponent={
        <div className="flex justify-end pt-6">
          <Button className="px-10 py-3.5" onClick={takeBLA}>
            Continue
          </Button>
        </div>
      }
      modalBoxClassName="md:w-[480px] !h-fit"
      modalId={modalId}
      onDismiss={takeBLA}
    >
      <div className="mt-3 md:mt-0 md:px-4 md:pt-4 lg:px-8 lg:pt-8">
        <div className="rounded-xl border p-4 md:px-6 md:py-8">
          <div className="flex -translate-y-2.5 translate-x-2.5 justify-end text-green">
            <ShareIcon />
          </div>
          <div className="flex flex-col items-center gap-4 pb-8">
            <div className="flex h-14 w-14 justify-center rounded-full bg-green-200 py-3">
              <TickCircleIcon />
            </div>
            <h3>Payment Success!</h3>
          </div>
          <div className="flex flex-col gap-3.5 border-y border-dashed border-gray pb-4 pt-8 text-sm">
            <div className="flex justify-between">
              <span className="text-gray">Reference Number</span>
              <span className="">{reference}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray">Date</span>
              <span className="">
                {moment(subscription?.created).format("MMM DD, YYYY")}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray">Time</span>
              <span className="">
                {" "}
                {moment(subscription.created).format("h:mm A")}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray">Payment Method</span>
              <span className="">Online Payment</span>
            </div>
          </div>
          <div className="flex justify-between pt-4">
            <p className="text-gray">Amount</p>
            <h6>{price}</h6>
          </div>
          <div className="pt-8 text-center">
            <Button intent="outline" leftIcon="download" shape="pill">
              Get PDF Receipt
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentSuccessfulModal;
